import { DateTime } from "luxon";

class DayPart {
  _atTime = null;

  constructor(props) {
    this.id = props.id;
    this._timezone = props.timezone || "UTC";
    this._helper = null;

    this._setProjectedTime(props.atTime);
  }

  /**
   * Set "At Time" to requested pickupTime defaulting to relative "now"
   *
   * @param {String} atTime  in "yyyy-MM-dd HH:mm" format
   */
  _setProjectedTime(atTime) {
    if (!atTime?.trim()?.length) {
      this._atTime = DateTime.now().setZone(this._timezone); // sets as "now" in Venue's Timezone
      return;
    }

    this._atTime = DateTime.fromFormat(atTime, "yyyy-MM-dd HH:mm").setZone(this._timezone);
  }

  isActive() {
    if (!this._helper) {
      throw Error("Helper must be of type DayPartHelper");
    }

    return this._hasStarted() && !this._hasEnded() && this._matchesDay() && this._matchesTime();
  }

  _hasStarted() {
    // SP-1863: converted time to unix for more reliable compares.
    return this._atTime.toUnixInteger() >= this._helper.beginDateTime.toUnixInteger();
  }

  _hasEnded() {
    // SP-1863: converted time to unix for more reliable compares.
    return this._atTime.toUnixInteger() >= this._helper.endDateTime.toUnixInteger();
  }

  _matchesDay() {
    return this._helper.repeatsAlways() || this._helper.matchesPeriod(this._atTime);
  }

  _matchesTime() {
    return this._helper.isAllDay() || this._helper.matchesTimeFrame(this._atTime);
  }
}

export default DayPart;
